import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/sites/page', data, {
    trim: true
  })
}

// 二维码列表
export function qrcodeList (id) {
  return request.get(`/business/locks/findLockBase?siteId=${id}`)
}

// 二维码列表
export function exportImages (data) {
  return request.post('/business/locks/exportImages?id='+data,null, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/sites/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/sites/updateById', data)
}
export function downloadImgs (id) {
  return request.get(`/business/locks/exportImages/id`)
}
// 删除
export function deleteById (id) {
  return request.get(`/business/sites/delete/${id}`)
}
